import { render, staticRenderFns } from "./InstrutoresHorariosAdminPage.vue?vue&type=template&id=b69f0fb4&scoped=true"
import script from "./InstrutoresHorariosAdminPage.vue?vue&type=script&lang=js"
export * from "./InstrutoresHorariosAdminPage.vue?vue&type=script&lang=js"
import style0 from "./InstrutoresHorariosAdminPage.vue?vue&type=style&index=0&id=b69f0fb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b69f0fb4",
  null
  
)

export default component.exports